import enUS from './en-US';
import de from './de';

export default {
  'en-US': enUS,
  de: { ...enUS, ...de },
};
